import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {ApiPathsService} from "../../api-paths.service";
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {VoceAcquisto} from "../_Models";
import {Permission} from "../../Login/_guards/Permission";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {ApiRestService} from "../api-rest.service";

@Component({
  selector: 'app-duplica-acquisto-modal',
  templateUrl: './duplica-acquisto-modal.component.html',
  styleUrls: ['./duplica-acquisto-modal.component.css']
})
export class DuplicaAcquistoModalComponent implements OnInit {
  @Input() Voce: VoceAcquisto;
  @Output() VoceChange = new EventEmitter<VoceAcquisto>();
  @Output() onDuplicaClick = new EventEmitter<VoceAcquisto>();
  List: Prodotto[] = [];
  duplicato: VoceAcquisto;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label',
    searchPlaceholderText: "Cerca",
    allowSearchFilter: true,
  }
  qty: number = 1;

  constructor(
    public modalService: NgbActiveModal,
    private apiPaths: ApiPathsService,
    private apiRestService: ApiRestService,
    public permission: Permission,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.duplicato = Object.assign({}, this.Voce);
    this.duplicato.id = undefined;
    this.duplicato.quantita = 0;
    this.duplicato.brandizzato = true;
    this.duplicato.codProdotto = this.Voce.prodottoObject?.label;
    this.duplicato.prodottoObject = undefined;
    this.duplicato.idProdottoNeutro = this.Voce.prodottoObject?.id;
    this.apiPaths.ClassicPost('/prodotti/list', {codice: this.duplicato.codProdotto, page: 0, size: 10}).subscribe(data => {
      this.List = data?.data.map(data=> {
        data.label = data.prodotto;
        return data
      });
    });
  }

  getnomi(data: any[]){
    var testo:string = "";
    data.forEach(element=> testo = testo + ' , ' + element?.nome)
    return testo;
  }

  Duplica(){
    if (this.qty >= this.Voce.quantita) {
      this.qty = this.Voce.quantita - 1;
      return this.toastrService.warning("La quantità da spostare non può essere maggiore o uguale a quella di partenza.");
    } else if (this.qty <= 0) {
      this.qty = 1;
      return this.toastrService.warning("La quantità da spostare non può essere minore o uguale a 0.")
    } else {
      this.Voce.quantita = this.Voce.quantita - this.qty;
      this.duplicato.quantita = this.qty
      this.onDuplicaClick.emit(this.duplicato);
      this.modalService.dismiss();
    }
  }

  onQtyChange(){
    if(this.qty >= this.Voce.quantita) {
      this.qty = this.Voce.quantita - 1;
      return this.toastrService.warning("La quantità da spostare non può essere maggiore o uguale a quella di partenza.");
    } else if(this.qty <= 0) {
      this.qty = 1;
      return this.toastrService.warning("La quantità da spostare non può essere minore o uguale a 0.")
    }
  }

  onProdottoChange() {
    this.apiRestService.ProdottiListinoProdottiGet({id: this.duplicato.idProdottoNeutro}).subscribe(data=>{
      data.data?.aggiunte?.forEach(element => {element.selected =  this.Voce?.aggiunte?.find(x => x == element.id) != undefined || element.selected;});
      this.duplicato.voce = this.duplicato.prodottoObject.label + this.getnomi(data?.data?.aggiunte?.filter(x=> x?.selected));
      this.duplicato.brand = this.duplicato.prodottoObject.label.replace(this.duplicato.codProdotto,"");
      this.duplicato.prodotto_id = this.duplicato.prodottoObject.id;
    });
  }
}
